import type { TerminalPlanBridge } from "./terminalPlanData";

export type TerminalBridgeBlock = { key: string; tag: string; kind: "neutral" | "live"; start: number; end: number; lane: number };

/** Shared by plan and list: inclusive intervals that touch the same row need separate lanes. */
export function packTerminalBridges(data: { rows: { neutral: TerminalPlanBridge[]; live: TerminalPlanBridge[] }[] }): TerminalBridgeBlock[] {
  const blocks = new Map<string, TerminalBridgeBlock>();
  for (const [index, row] of data.rows.entries()) {
    for (const kind of ["neutral", "live"] as const) for (const info of row[kind]) {
      if (!info.dot && !info.incoming && !info.outgoing) continue;
      const key = `${kind}:${info.id}`;
      const block = blocks.get(key);
      if (block) block.end = index;
      else blocks.set(key, { key, tag: info.tag, kind, start: index, end: index, lane: 0 });
    }
  }
  const sorted = [...blocks.values()].sort((a, b) => a.start - b.start || a.end - b.end || a.key.localeCompare(b.key));
  const ends: number[] = [];
  for (const block of sorted) {
    let lane = ends.findIndex(end => end < block.start);
    if (lane < 0) lane = ends.length;
    ends[lane] = block.end; block.lane = lane;
  }
  return sorted;
}
